import { useQuery } from "@tanstack/react-query"
import { ApplicationRoleApproverGet } from "../app/models/ApplicationRoleApprover"
import { Guid } from "../app/models/CustomType"
import { digitalManagerApi } from "../services/api"

export function useApprovers(applicationId?: Guid, roleId?: Guid) {
  const { data: approversList = [], isLoading: isLoadingApprovers } = useQuery({
    queryKey: ["approvers", applicationId, roleId],
    queryFn: () =>
      digitalManagerApi
        .get<
          ApplicationRoleApproverGet[]
        >(`/applications/${applicationId}/roles/${roleId}/approvers`)
        .then((r) => r.data),
    enabled: !!applicationId && !!roleId,
  })

  return {
    approversList,
    isLoadingApprovers,
  }
}
